// Translation dictionary — locale files live in ./locales
import { EN_TRANSLATIONS } from './locales/en';
import { AR_TRANSLATIONS } from './locales/ar';
import { UR_TRANSLATIONS } from './locales/ur';
import { ES_TRANSLATIONS } from './locales/es';
import { ZH_TRANSLATIONS } from './locales/zh';
import { PA_TRANSLATIONS } from './locales/pa';

export const TRANSLATIONS: { [key: string]: { [key: string]: string } } = {
  en: EN_TRANSLATIONS,
  ar: AR_TRANSLATIONS,
  ur: UR_TRANSLATIONS,
  es: ES_TRANSLATIONS,
  zh: ZH_TRANSLATIONS,
  pa: PA_TRANSLATIONS
};
